import React from 'react';
import Box from '@mui/material/Box';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
const SX = {
    banner:{
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        textRendering: 'optimizeLegibility',
        display: 'flex',
        flexDirection:'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '32px',
        paddingBlock: '6px',
        paddingInline: '1rem',
        backgroundColor: '#193133',
        textAlign: 'center',
        '& .banner-text':{
            color: '#fff',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '160%',
            "& strong": {
                fontWeight: 600
            }
        },
        '& .banner-link':{
            color:  '#D0FF71',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '160%',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            transition: 'opacity .2s ease',
            margin: '0 5px',
        },
        '& .banner-arrow':{
            display: 'inline-block',
            transition: 'transform .25s ease',
            WebkitTextDecorationSkip: 'ink',
            textDecorationSkipInk: 'auto',
            color: 'currentColor'
        },
        '& .banner-arrow-icon':{
            '& svg':{
                verticalAlign:'middle',
                fontSize:'1rem',
                transition: 'transform .25s ease',
            }
        },
        '& .banner-link:hover, .banner-link:focus-visible': {
            color: '#D0FF71',
            opacity: .8
        },
        '& .banner-link:hover .banner-arrow, .banner-link:hover .banner-arrow-icon svg': {
            transform: 'translate(4px)'
        }

    },
    bannerText:{
        color: '#fff',
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '160%',
    }
}
const SpecialAnnouncement = () => {

  return (
      <Box sx={SX.banner}>
        <span class="banner-text"><strong>iNaira is now part of LeadingReach.</strong></span>
        <div>
            <span class="banner-text"> <strong>iNaira's EHR integration and automation capabilities</strong> are now built into the LeadingReach Network—the largest verified referral network in healthcare.</span>
            <a href="https://leadingreach.com/news/leadingreach-is-ready-so-is-the-network/" class="banner-link">
                Read the announcement&nbsp;<span className='banner-arrow-icon'><ArrowForwardIcon/></span>
            </a>
            <a href="https://leadingreach.com" class="banner-link">
                Visit LeadingReach&nbsp;<span className='banner-arrow-icon'><ArrowForwardIcon/></span>
            </a>
        </div>
        
        
      </Box>
  );
}

export default SpecialAnnouncement